module.exports = __webpack_public_path__ + "public/images/tiger.61397f92d6ec1ac87f1bd78b67d28a57.png";